import styled, { css } from 'styled-components';
import { flexVerticalMiddle } from '../../../../utils/style';
import { StyledLabel } from '../../../chat/Label/Styled';
import { StyledSubLabel } from '../../../chat/SubLabel/Styled';

export const StyledLogoSettingWrapper = styled.div<{ displayLarge?: boolean }>`
  margin-bottom: 1.5rem;

  ${(props) =>
    props.displayLarge &&
    css`
      ${StyledTitleWrap} {
        display: block;

        .title-text-wrap {
          ${StyledLabel} {
            font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
            line-height: 1.5rem;
            margin-bottom: 0.75rem;
          }

          ${StyledSubLabel} {
            font-size: ${(props) => props.theme.fontSizes.text.fontSize};
            line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
          }
        }

        .upload-info-wrap {
          margin: 0.75rem 0 0 0;
        }

        .image-select-button {
          border-width: 2px;
          padding: 0.5rem 1.5rem 0.5rem 1rem;
          font-size: ${(props) => props.theme.fontSizes.h5.fontSize};
          line-height: 1.2;

          .ch-icon + .ch-label {
            margin-left: 1rem;
          }
        }

        .image-info {
          margin-left: 0.5rem;
          font-size: ${(props) => props.theme.fontSizes.text.fontSize};
          line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
        }

        .error-text {
          margin-top: 0.5rem;
          font-size: ${(props) => props.theme.fontSizes.text.fontSize};
          line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
        }
      }

      ${StyledImageIconWrap} {
        margin-top: 1.25rem;
        width: 7.5rem;
        text-align: center;
      }

      ${({ theme }) => theme.mediaQueries.min.md} {
        ${StyledTitleWrap} {
          .title-text-wrap {
            ${StyledLabel} {
              font-size: ${(props) => props.theme.fontSizes.h5.fontSize};
            }
          }

          .upload-info-wrap {
            margin: 1.25rem 0 0 0;
          }

          .image-select-button {
            font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
          }

          .image-info {
            margin-left: 1.5rem;
          }
        }
      }
    `}
`;

export const StyledTitleWrap = styled.div`
  & {
    .upload-info-wrap {
      display: grid;
      align-items: center;
    }

    .button-wrap {
      ${flexVerticalMiddle}
      order: 1;
      margin-top: 1rem;
    }

    .image-select-button {
      flex-shrink: 0;
    }

    .image-info {
      margin-left: 0.5rem;
      font-size: ${(props) => props.theme.fontSizes.exSmall.fontSize};
      line-height: ${(props) => props.theme.fontSizes.exSmall.lineHeight};
      word-break: break-all;
    }

    .error-text {
      font-size: ${(props) => props.theme.fontSizes.exSmall.fontSize};
      line-height: ${(props) => props.theme.fontSizes.exSmall.lineHeight};
      margin-top: 0.25rem;
      order: 2;
    }

    .image-reset-wrapper {
      margin-top: 1rem;
    }

    .image-reset-link {
      display: inline-block;
      font-size: ${(props) => props.theme.fontSizes.small.fontSize};
      margin-right: 0.5rem;
      margin-bottom: 0.25rem;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    display: flex;

    & {
      .title-text-wrap {
        flex: 0 0 auto;
      }

      .upload-info-wrap {
        flex: 1;
        margin-left: 1rem;
        position: relative;
      }

      .button-wrap {
        order: 0;
        margin-top: 0;
      }

      .error-text {
        margin-top: 0.375rem;
        order: 0;
      }

      .image-reset-wrapper {
        margin-top: 0.5rem;
        display: flex;
        align-items: baseline;
      }

      .image-reset-link {
        margin-bottom: 0;
      }
    }
  }
`;

export const StyledImageIconWrap = styled.div`
  margin-top: 1rem;

  img {
    border-radius: ${(props) => props.theme.radii.circle};
    line-height: 0;
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    margin-top: 0.75rem;
  }
`;

export const StyleImageResetModalWrap = styled.div<{
  noImage?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${(props) => (props.noImage ? '2.25rem' : '0.5rem')};
  margin-bottom: ${(props) => (props.noImage ? '1.5rem' : '0')};

  & {
    .image-wrapper {
      margin-top: 2rem;
      margin-bottom: 0.5rem;
    }

    .button {
      font-weight: normal;
      margin-top: ${(props) => (props.noImage ? '2.75rem' : '2.25rem')};
    }
  }
`;
